import { Helpers, DtoKeys } from '@bode-canada/core';
import BuildingClassMapper from '@/components/features/search/shared/mappers/BuildingClassMapper';
import { MAX_PRICE } from '@/components/filters/constants/options';
import ApiQueryMapper from '../../sold-data/mappers/ApiQueryMapper';
import {
  EXCLUDED_COMMUNITY_NONE_VALUE,
} from '@/components/page-specific/listing/summary/constants';

const { SearchListingFilterDtoKey } = DtoKeys;

export default class FilterMapper {
  static mapToDto(filter) {
    const minClosedAtValue = ApiQueryMapper.getMinClosedAtDate(filter.transactionDate);
    const buildingClassesQuery = filter.buildingClass?.length
      ? {
        [SearchListingFilterDtoKey.BUILDING_CLASSES]: BuildingClassMapper
          .mapFilterToQuery(filter.buildingClass).buildingClass,
      }
      : {};

    return this.#removeEmptyProperties({
      [SearchListingFilterDtoKey.CITY]: filter.city,
      [SearchListingFilterDtoKey.COMMUNITY]: this.#removeEmptyProperties(
        filter.community.filter((item) => item !== EXCLUDED_COMMUNITY_NONE_VALUE),
      ),
      [SearchListingFilterDtoKey.CLOSED_AT]: minClosedAtValue && { min: minClosedAtValue },
      [SearchListingFilterDtoKey.BEDS]: filter.beds && this.#removeEmptyProperties(filter.beds),
      [SearchListingFilterDtoKey.BATHS]: filter.baths && this.#removeEmptyProperties(filter.baths),
      [SearchListingFilterDtoKey.PRICE]: this.#getRange(
        filter.minPrice,
        filter.maxPrice === MAX_PRICE ? null : filter.maxPrice,
      ),
      [SearchListingFilterDtoKey.YEAR_BUILT]:
        this.#getRange(filter.minYearBuilt, filter.maxYearBuilt),
      [SearchListingFilterDtoKey.ORIGINS]: this.#removeEmptyProperties([filter.origin]),
      ...buildingClassesQuery,
    });
  }

  static #removeEmptyProperties(input) {
    const result = Array.isArray(input)
      ? input.filter(((item) => item))
      : Helpers.ObjectHelper.removeEmptyProperties(input);

    return this.#checkObjectFields(result);
  }

  static #getRange(min, max) {
    return this.#removeEmptyProperties({
      min: min && Number(min),
      max: max && Number(max),
    });
  }

  static #checkObjectFields(input) {
    return Object.keys(input).length ? input : null;
  }
}
